<template>
<v-data-table
    :dense="dense"
    v-model="data"
    :show-select="showSelect"
    :item-key="itemKey"
    :headers="headers"
    :items="items"
    :server-items-length="totalRows"
    :page="options.page"
    :items-per-page="options.itemsPerPage"
    :sort-by="options.sortBy"
    :sort-desc="options.sortDesc"
    :multi-sort="options.multiSort"
    :must-sort="options.mustSort"
    @update:options="options = $event;"
    :loading="loading"
    :disable-sort="disabled"
    mobile-breakpoint="0"
    hide-default-header
    hide-default-footer
    :class="contentClass"
>
    <template>
        <v-row class="my-1" :dense="dense" v-if="!countHide && !customHide && !createdHide && !downloadHide && !itemsPerPageHide">
            <v-col class="d-flex justify-start align-end">
                <template v-if="!countHide">
                    <div style="width: 200px;">
                        <h3 class="text-left">{{count}}</h3>
                    </div>
                </template>
                <template v-if="!customHide">
                    <v-btn elevation="0" class="btn-blue ml-auto" @click="customFunction">{{customButtonTxt !== undefined && customButtonTxt != null ? customButtonTxt : ""}}</v-btn>
                </template>
                <template v-if="!createdHide">
                    <v-btn elevation="0" :class="`btn-blue ${customHide ? 'ml-auto' : 'ml-1'}`" @click="moveCreatePage()">등록</v-btn>
                </template>
                <template v-if="!downloadHide">
                    <v-btn elevation="0" :class="`btn-blue ${customHide ? 'ml-auto' : 'ml-1'}`" @click="download">엑셀다운</v-btn>
                </template>
                <template v-if="!itemsPerPageHide">
                    <div style="width: 150px;" :class="(downloadHide && customHide) ? 'ml-auto' : 'ml-1'">
                      <v-select
                          dense
                          outlined
                          hide-details="auto"
                          :value="options.itemsPerPage"
                          :items="paginationList"
                          @change="options.itemsPerPage = $event; options.page = 1;"
                         >
                      </v-select>
                   </div>
                </template>
            </v-col>
        </v-row>
    </template>
    <template v-slot:header="headerSlot">
        <thead class="v-data-table-header">
            <template v-if="maxRow === 1">
                <tr>
                    <template v-if="showSelect">
                            <th scope="col" class="text-start" style="width: 1px; min-width: 1px;">
                                <template v-if="multipleSelect">
                                    <v-checkbox
                                        v-model="checkAll"
                                        @change="headerSlot.on['toggle-select-all']"
                                        :disabled="items.length === 0"
                                        :indeterminate="indeterminate"
                                        class="radio--margin-none"
                                        hide-details
                                        color="normal"
                                        style="margin: auto !important; max-width: fit-content;"
                                    />
                                </template>
                                <template v-else>
                                </template>
                            </th>
                    </template>
                    <template v-for="(header, headerKey) in headers">
                        <th :key="headerKey"
                            v-if="($vuetify.breakpoint.mdAndDown ? !header.isNotMobile : true)"
                            @click="header.sortable && items.length > 0 ? headerSlot.on.sort(header.value) : null"
                            scope="col"
                            :colspan="header.colspan"
                            :rowspan="header.rowspan"
                            :class="(header.sortable && items.length > 0  ? 'sortable' : '') + (headerSlot.props.options.sortBy.indexOf(header.value) !== -1 ? ' active' : '')"
                            class="text-center"
                            :style="header.width ? (isNaN(Number(header.width)) ? ('width: ' + header.width + '; min-width: ' + header.width +';'): ('width: ' + header.width + 'px; min-width: ' + header.width + 'px;')) : ''"
                        >
                            <template>
                                <runtime-template-compiler :template="`&lt;span class='ma-0 pa-0'&gt;${header.text !== undefined && header.text != null ? header.text : ''}&lt;/span&gt;`"/>
                            </template>
                            <template v-if="header.sortable&& items.length > 0">
                             <v-icon
                                 size="18"
                                 class="v-data-table-header__icon"
                             >
                                 <template v-if="headerSlot.props.options.sortDesc[headerSlot.props.options.sortBy.indexOf(header.value)]">
                                     mdi-arrow-down
                                 </template>
                                 <template v-else>
                                     mdi-arrow-up
                                 </template>
                             </v-icon>
                            </template>
                        </th>
                    </template>
                </tr>
            </template>
            <template v-else>
                <template v-for="(row, rowkey) in maxRow">
                    <tr :key="rowkey">
                        <template v-if="showSelect && row === 1">
                            <th :rowspan="maxRow" scope="col" class="text-start" style="width: 1px; min-width: 1px;">
                                <template v-if="multipleSelect">
                                    <v-checkbox
                                        v-model="checkAll"
                                        @change="headerSlot.on['toggle-select-all']"
                                        :disabled="items.length === 0"
                                        :indeterminate="indeterminate"
                                        class="radio--margin-none"
                                        hide-details
                                        color="normal"
                                        style="margin: auto !important; max-width: fit-content;"
                                    />
                                </template>
                                <template v-else>
                                </template>
                            </th>
                        </template>
                        <template v-for="(header, headerKey) in headers">
                            <div v-if="row === header.row" :key="headerKey">
                                <th
                                    v-if="($vuetify.breakpoint.mdAndDown ? !header.isNotMobile : true)"
                                    @click="header.sortable && items.length > 0 ? headerSlot.on.sort(header.value) : null"
                                    scope="col"
                                    :colspan="header.colspan"
                                    :rowspan="header.rowspan"
                                    :class="(header.sortable && items.length > 0  ? 'sortable' : '') + (headerSlot.props.options.sortBy.indexOf(header.value) !== -1 ? ' active' : '')"
                                    :style="header.width ? (isNaN(Number(header.width)) ? ('width: ' + header.width + '; min-width: ' + header.width +';'): ('width: ' + header.width + 'px; min-width: ' + header.width + 'px;')) : ''"
                                >
                                    <template>
                                        <runtime-template-compiler :template="`&lt;span class='ma-0 pa-0'&gt;${header.text !== undefined && header.text != null ? header.text : ''}&lt;/span&gt;`"/>
                                    </template>
                                    <template v-if="header.sortable&& items.length > 0">
                                        <v-icon
                                            size="18"
                                            class="v-data-table-header__icon"
                                        >
                                            <template v-if="headerSlot.props.options.sortDesc[headerSlot.props.options.sortBy.indexOf(header.value)] === 'true' || headerSlot.props.options.sortDesc[headerSlot.props.options.sortBy.indexOf(header.value)] === true">
                                                mdi-arrow-down
                                            </template>
                                            <template v-else>
                                                mdi-arrow-up
                                            </template>
                                        </v-icon>
                                    </template>
                                </th>
                            </div>
                        </template>
                    </tr>
                </template>
            </template>
        </thead>
    </template>
    <template v-if="items.length !== 0" v-slot:body="props">
        <tbody
            :key="dataTableRepaint">
            <tr :class="getClass(rowClassConditional, item)" v-for="(item, rKey) in props.items" :key="item[itemKey]">
                <td v-if="showSelect" :key="rKey">
                    <container
                        class="ma-0 pa-0 d-flex justify-center align-center" style="width:100%; height: 100%;">
                        <template v-if="isTrue(checkboxConditional, item)">
                            <template v-if="multipleSelect">
                                <v-checkbox
                                    v-model="data"
                                    :value="item"
                                    multiple
                                    class="radio--margin-none"
                                    hide-details
                                    style="margin: auto !important; max-width: fit-content;"
                                />
                            </template>
                            <template v-else>
                                <v-radio-group v-model="rediaoData">
                                    <v-radio
                                    class="radio--margin-none"
                                    hide-details
                                    :value="item"/>
                                </v-radio-group>
                            </template>
                        </template>
                    </container>
                </td>
                <template v-for="(header, headerKey) in headers">
                    <td  :key="headerKey" v-if="!header.colspan && ($vuetify.breakpoint.mdAndDown ? !header.isNotMobile : true)" :class="header.cellClass" @click="clickRow(item)">
                        <template v-if="header.prependText !== undefined && header.prependText !== null && header.prependText !== ''">
                            <span>{{header.prependText}}</span>
                        </template>
                        <template v-if="header.type === 'icon'">
                            <v-icon
                                class="mr-2"
                                @click.stop="clickIcon(item, header.value)"
                            >{{cell[header.type][header.value].title}}</v-icon>
                        </template>
                        <template v-else-if="header.type === 'button'">
                            <v-btn
                                v-if="isTrue(cell[header.type][header.value].conditional, item)"
                                hide-details
                                :x-small="cell[header.type][header.value].xsmall"
                                :small="cell[header.type][header.value].small"
                                :x-large="cell[header.type][header.value].xlarge"
                                :large="cell[header.type][header.value].large"
                                :class="cell[header.type][header.value].contentClass"
                                @click.native.stop="clickButton(item, header.value)"
                            >{{item[header.value] ? item[header.value] : cell[header.type][header.value].title}}</v-btn>
                        </template>
                        <template v-else-if="header.type === 'textField'">
                            <v-text-field
                                hide-details
                                @click.stop
                                @input="inputTextField($event, item, header.value)"
                                dense
                                outlined
                                :suffix="cell[header.type][header.value].suffix"
                            ></v-text-field>
                        </template>
                        <template v-else-if="header.type === 'img'">
                            <v-img
                                v-if="item[header.value] !== undefined && item[header.value] !== null && item[header.value] !== ''"
                                :src="cell[header.type][header.value].src"
                                :alt="cell[header.type][header.value].alt"
                                :width="cell[header.type][header.value].width"
                                :height="cell[header.type][header.value].height"
                                :class="cell[header.type][header.value].contentClass"
                                @click.stop="clickImg(item, header.value)"
                            ></v-img>
                        </template>
                        <template v-else-if="header.type === 'textImage'">
                            <v-row :class="cell[header.type][header.value].contentClass">
                                <v-col cols="auto" class="pr-0">
                                    {{item[header.value]}}
                                </v-col>
                                <v-col class="pl-0">
                                    <v-img
                                        v-if="isTrue(cell[header.type][header.value].conditional, item)"
                                        :src="cell[header.type][header.value].src"
                                        :alt="cell[header.type][header.value].alt"
                                        :width="cell[header.type][header.value].width"
                                        :height="cell[header.type][header.value].height"
                                        @click.native.stop="clickImg(item, header.value)"
                                    ></v-img>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-else-if="header.type === 'styleText'">
                            <span
                                :class="getClass(cell[header.type][header.value].conditional, item)"
                                @click.stop="clickStyleText(item, header.value)"
                            >{{item[header.value]}}</span>
                        </template>
                        <template v-else-if="header.type === 'currency'">
                            <span>{{numeral(item[header.value]).format("0,0")}}</span>
                        </template>
                        <template v-else-if="header.type === 'tooltip'">
                            <v-tooltip top>
                                <template v-slot:activator="act">
                                    <span v-on="act.on" v-bind="act.attrs">{{item[header.value]}}</span>
                                </template>
                                {{item[header.value]}}
                            </v-tooltip>
                        </template>
                        <template v-else-if="header.type === 'html'">
                            <div @click.stop="clickHtml(item, header.value)">
                                <template>
                                    <runtime-template-compiler :template="`&lt;v-container class='ma-0 pa-0'&gt;${item[header.value] !== undefined && item[header.value] != null ? item[header.value] : ''}&lt;/v-container&gt;`"/>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <span>{{item[header.value]}}</span>
                        </template>
                        <template v-if="header.appendText !== undefined && header.appendText !== null && header.appendText !== ''">
                            <span>{{header.appendText}}</span>
                        </template>
                    </td>
                </template>
            </tr>
        </tbody>
    </template>
    <template v-else v-slot:body>
        <tbody>
            <tr>
                <td v-if="loading" :colspan="headers.length + (showSelect ? 1 : 0)" class="text-center">
                    <h4 style="opacity: 0.4;">데이터 가져오는 중...</h4>
                </td>
                <td v-else :colspan="headers.length + (showSelect ? 1 : 0)" class="text-center">
                    <div class="py-3">
                        <v-icon size="200" style="opacity: 0.12;">
                            mdi-database-remove-outline
                        </v-icon>
                        <br>
                        <h4 style="opacity: 0.4;">데이터가 없습니다.</h4>
                    </div>
                </td>
            </tr>
        </tbody>
    </template>
    <template v-slot:footer>
        <v-row dense>
            <v-col cols="12" class="pa-0">
                <div class="text-center my-4" >
                    <v-pagination
                        class="d-inline-block"
                        :length="Math.ceil(totalRows / options.itemsPerPage)"
                        :total-visible="10"
                        v-model="options.page"
                        :disabled="disabled"
                    ></v-pagination>
                </div>
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-end align-center">
                <v-btn
                    v-if="!uploadHide"
                    color="primary"
                    @click="excelUpload"
                >업로드</v-btn>
                <v-btn
                    v-if="!addHide"
                    class="ml-3"
                    @click="add"
                >추가</v-btn>
                <v-btn
                    v-if="!removeHide"
                    class="ml-3"
                    @click="remove"
                >삭제</v-btn>
            </v-col>
        </v-row>
    </template>
 </v-data-table>
</template>

<script lang="ts">
import Vue from 'vue';
import RuntimeTemplateCompiler from 'vue-runtime-template-compiler';

Vue.use(RuntimeTemplateCompiler);

export default Vue.component('data-table-custom-component', {
    props: {
        headers: {
            type: Array,
            default() {
                return [];
            },
        },
        items: {
            type: Array,
            default() {
                return [];
            },
        },
        itemClass: {
            type: String,
            default: '',
        },
        totalRows: {
            type: Number,
            default: 0,
        },
        uploadHide: {
            type: Boolean,
            default: false,
        },
        customHide: {
            type: Boolean,
            default: true,
        },
        customButtonTxt: {
            type: String,
            default: '',
        },
        addHide: {
            type: Boolean,
            default: false,
        },
        removeHide: {
            type: Boolean,
            default: false,
        },
        showSelect: {
            type: Boolean,
            default: false,
        },
        multipleSelect: {
            type: Boolean,
            default: true,
        },
        itemKey: {
            type: String,
            default: 'id',
        },
        downloadHide: {
            type: Boolean,
            default: false,
        },
        createdHide: {
            type: Boolean,
            default: true,
        },
        search: {
            type: Boolean,
            default: false,
        },
        page: {
            type: Number,
            default: 1,
        },
        itemsPerPage: {
            type: Number,
            default: 10,
        },
        sortBy: {
            type: Array,
            default() {
                return [];
            },
        },
        sortDesc: {
            type: Array,
            default() {
                return [];
            },
        },
        groupBy: {
            type: Array,
            default() {
                return [];
            },
        },
        groupDesc: {
            type: Array,
            default() {
                return [];
            },
        },
        multiSort: {
            type: Boolean,
            default: false,
        },
        mustSort: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        importHide: {
            type: Boolean,
            default: false,
        },
        countTitle: {
            type: Object,
            default: () => ({
                front: '전체',
                end: '건',
            }),
        },
        cell: {
            type: Object,
            default() {
                return {};
            },
        },
        selectedItemProps: {
            type: Array,
            default() {
                return [];
            },
        },
        checkboxConditional: {
            type: Object,
            default: null,
        },
        researchFlag: {
            type: Number,
            default: 0,
        },
        dataProps: {
            type: Array,
            default() {
                return [];
            },
        },
        radioProps: {
            type: Object,
            default: null,
        },
        dataTableRepaint: {
            type: Number,
            default: 1,
        },
        contentClass: {
            type: String,
            default: 'tableline',
        },
        dense: {
            type: Boolean,
            default: false,
        },
        countHide: {
            type: Boolean,
            default: false,
        },
        maxRow: {
            type: Number,
            default: 1,
        },
        rowClassConditional: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            paginationList: [
                { text: '5개 보기', value: 5 },
                { text: '10개 보기', value: 10 },
                { text: '15개 보기', value: 15 },
                { text: '20개 보기', value: 20 },
                { text: '25개 보기', value: 25 },
                { text: '30개 보기', value: 30 },
                { text: '전체 보기', value: null },
            ],
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: false,
                mustSort: false,
            },
            data: [] as any,
            rediaoData: null,
            checkAll: false,
            indeterminate: false,
            checkTotal: null as any,
        };
    },
    watch: {
        dataProps: {
            handler(val: Array<any>) {
                this.data = val;
            },
            deep: true,
        },
        radioProps: {
            handler(n: any) {
                this.rediaoData = n;
            },
            deep: true,
        },
        options: {
            handler(n: any) {
                this.$emit('reload', n);
            },
            deep: true,
        },
        loading: {
            handler(n: any) {
                if (!n) {
                    this.data = [];
                    if (this.checkboxConditional !== null) {
                        let c = 0;
                        this.items.forEach((e) => {
                            if (this.isTrue(this.checkboxConditional, e)) {
                                c += 1;
                            }
                        });
                        this.checkTotal = c;
                    } else {
                        this.checkTotal = this.options.itemsPerPage;
                    }
                }
            },
            deep: true,
        },
        search: {
            handler(n: any) {
                if (n) {
                    if (this.options.page !== 1) {
                        this.options.page = 1;
                    } else {
                        this.$emit('reload', this.options);
                    }
                }
            },
        },
        researchFlag: {
            handler(n: any, o: any) {
                if (n !== o) {
                    this.$emit('reload', this.options);
                }
            },
        },
        data: {
            handler(n: any) {
                let item = [];
                if (this.items.length === 0) {
                    this.checkAll = false;
                    this.indeterminate = false;
                } else {
                    if (this.checkboxConditional !== null) {
                        n.forEach((e: any) => {
                            if (this.isTrue(this.checkboxConditional, e)) {
                                item.push(e);
                            }
                        });
                    } else {
                        item = n;
                    }
                    this.$emit('selected', item);
                    if (item.length === this.checkTotal) {
                        this.checkAll = true;
                        this.indeterminate = false;
                    } else if (item.length === 0) {
                        this.checkAll = false;
                        this.indeterminate = false;
                    } else {
                        this.checkAll = false;
                        this.indeterminate = true;
                    }
                }
            },
            deep: true,
        },
        rediaoData: {
            handler(n) {
                let item = null;
                if (this.items.length === 0) {
                    this.indeterminate = false;
                } else {
                    if (this.checkboxConditional !== null) {
                        if (this.isTrue(this.checkboxConditional, n)) {
                            item = n;
                        }
                    } else {
                        item = n;
                    }
                    this.$emit('selected', item);
                    if (n !== undefined && n != null) {
                        this.indeterminate = false;
                    } else {
                        this.indeterminate = true;
                    }
                }
            },
            deep: true,
        },
        items: {
            handler() {
                this.$emit('dataTableRepaint', this.dataTableRepaint + 1);
            },
            deep: true,
        },
    },
    computed: {
        disabled() {
            return !!(this.loading || this.totalRows === 0);
        },
        count() {
            return `${this.countTitle.front} ${this.totalRows}${this.countTitle.end}`;
        },
    },
    methods: {
        clickRow(e: any) {
            this.$emit('click:row', e);
        },
        excelUpload() {
            this.$emit('upload');
        },
        remove() {
            this.$emit('remove', this.data);
        },
        add() {
            this.$emit('add');
        },
        clickIcon(item: any, header: any) {
            const clicked = { item, header };
            this.$emit('click:icon', clicked);
        },
        changeAutocomplete(id: any, header: any, item: any) {
            const selected = { id, header, item };
            this.$emit('change:autocomplete', selected);
        },
        clickButton(item: any, header: any) {
            const clicked = { item, header };
            this.$emit('click:button', clicked);
        },
        inputTextField(value: any, item: any, header: any) {
            const clicked = { value, item, header };
            this.$emit('input:textField', clicked);
        },
        inputClickAfterTextField(value: any, item: any, header: any) {
            const clicked = { value, item, header };
            this.$emit('input:clickAfterTextField', clicked);
        },
        download() {
            this.$emit('download');
        },
        customFunction() {
            this.$emit('customFunction');
        },
        clickImg(item: any, header: any) {
            const clicked = { item, header };
            this.$emit('click:img', clicked);
        },
        clickMultiButton(item: any, header: any, title: any) {
            const clicked = { item, header, title };
            this.$emit('click:multiButton', clicked);
        },
        isTrue(conditional: any, item: any) {
            if (conditional !== undefined && conditional !== null) {
                if (conditional[0] === undefined) {
                    switch (conditional.inequality) {
                    case 'gt':
                        return item[conditional.column] > conditional.target;
                    case 'ge':
                        return item[conditional.column] >= conditional.target;
                    case 'lt':
                        return item[conditional.column] < conditional.target;
                    case 'le':
                        return item[conditional.column] <= conditional.target;
                    case 'eq':
                        return item[conditional.column] === conditional.target;
                    case 'ne':
                        return item[conditional.column] !== conditional.target;
                    case 'nu':
                        return item[conditional.column] !== undefined;
                    case 'nn':
                        return item[conditional.column] != null;
                    case 'nb':
                        return item[conditional.column] !== '';
                    case 'nunb':
                        return item[conditional.column] !== undefined && item[conditional.column] != null && item[conditional.column] !== '';
                    case 'iu':
                        return item[conditional.column] === undefined;
                    case 'in':
                        return item[conditional.column] == null;
                    case 'ib':
                        return item[conditional.column] === '';
                    case 'iunb':
                        return item[conditional.column] === undefined || item[conditional.column] == null || item[conditional.column] === '';
                    default:
                        return false;
                    }
                } else {
                    let bool = true;
                    for (let i = 0; i < conditional.length; i += 2) {
                        let subBool = true;
                        const data = conditional[i];
                        switch (conditional[i].inequality) {
                        case 'gt':
                            subBool = item[data.column] > data.target;
                            break;
                        case 'ge':
                            subBool = item[data.column] >= data.target;
                            break;
                        case 'lt':
                            subBool = item[data.column] < data.target;
                            break;
                        case 'le':
                            subBool = item[data.column] <= data.target;
                            break;
                        case 'eq':
                            subBool = item[data.column] === data.target;
                            break;
                        case 'ne':
                            subBool = item[data.column] !== data.target;
                            break;
                        case 'nu':
                            subBool = item[data.column] !== undefined;
                            break;
                        case 'nn':
                            subBool = item[data.column] != null;
                            break;
                        case 'nb':
                            subBool = item[data.column] !== '';
                            break;
                        case 'nunb':
                            subBool = item[data.column] !== undefined && item[data.column] != null && item[data.column] !== '';
                            break;
                        case 'iu':
                            subBool = item[data.column] === undefined;
                            break;
                        case 'in':
                            subBool = item[data.column] == null;
                            break;
                        case 'ib':
                            subBool = item[data.column] === '';
                            break;
                        case 'iunb':
                            subBool = item[data.column] === undefined || item[data.column] == null || item[data.column] === '';
                            break;
                        default:
                            subBool = false;
                        }
                        if (i === 0) {
                            bool = subBool;
                        } else if (conditional[i - 1].toUpperCase() === 'AND') {
                            bool = bool && subBool;
                        } else if (conditional[i - 1].toUpperCase() === 'OR') {
                            bool = bool || subBool;
                        }
                    }
                    return bool;
                }
            } else {
                return true;
            }
        },
        getClass(conditional: any, item: any) {
            let bool = false;
            if (conditional !== undefined && conditional !== null) {
                switch (conditional.inequality) {
                case 'gt':
                    bool = item[conditional.column] > conditional.target;
                    break;
                case 'ge':
                    bool = item[conditional.column] >= conditional.target;
                    break;
                case 'lt':
                    bool = item[conditional.column] < conditional.target;
                    break;
                case 'le':
                    bool = item[conditional.column] <= conditional.target;
                    break;
                case 'eq':
                    bool = item[conditional.column] === conditional.target;
                    break;
                case 'ne':
                    bool = item[conditional.column] !== conditional.target;
                    break;
                case 'nu':
                    bool = item[conditional.column] !== undefined;
                    break;
                case 'nn':
                    bool = item[conditional.column] != null;
                    break;
                case 'nb':
                    bool = item[conditional.column] !== '';
                    break;
                case 'nunb':
                    bool = item[conditional.column] !== undefined && item[conditional.column] != null && item[conditional.column] !== '';
                    break;
                case 'iu':
                    bool = item[conditional.column] === undefined;
                    break;
                case 'in':
                    bool = item[conditional.column] == null;
                    break;
                case 'ib':
                    bool = item[conditional.column] === '';
                    break;
                case 'iunb':
                    bool = item[conditional.column] === undefined || item[conditional.column] == null || item[conditional.column] === '';
                    break;
                default:
                    bool = false;
                }
                if (bool) {
                    return conditional.cssClass;
                }
                return conditional.defaultClass !== undefined && conditional.defaultClass !== null ? conditional.defaultClass : '';
            }
            return '';
        },
        clickStyleText(item: any, header: any) {
            const clicked = { item, header };
            this.$emit('click:styleText', clicked);
        },
        clickHtml(item: any, header: any) {
            const clicked = { item, header };
            this.$emit('click:html', clicked);
        },
        toggleStatus(headerType: any, rKey: any) {
            this.$set(this.cell[headerType].readonlyFlag, rKey, false);
        },
        enterTextField(item: any, headerType: any, rKey: any) {
            item.memo = this.cell[headerType].memo[rKey];
            this.$set(this.cell[headerType].readonlyFlag, rKey, true);
            this.$emit('enter:clickAfterTextField', item);
        },
        moveCreatePage() {
            this.$router.push({
                path: '/asisadmin/user/write',
            });
        },
    },
});
</script>

<style scoped>
</style>
